import HotelPackageSet from '../hotel/HotelPackageSet';
import BundlePackageLoader from './BundlePackageLoader';
import type BundlePackage from './BundlePackage';
import { type BundlePackageLoaderConfig } from './types';
import type HotelPackage from '@itinerary/hotel/HotelPackage';
import ItineraryPackageSet from '@itinerary/ItineraryPackageSet';
import { type FilterKey } from '@itinerary/ItineraryModuleTypes';
import {
    type HotelFilterData,
    HotelSortBy,
} from '@itinerary/hotel/HotelModuleTypes';

/**
 * Stores data related to a list of packages, that one of them must be chosen
 */
export default class BundlePackageSet extends ItineraryPackageSet<
    HotelFilterData,
    FilterKey,
    BundlePackage
> {
    /**
     * The package loader associated with this set
     */
    protected override loader: BundlePackageLoader;
    /**
     * The list of packages
     */
    protected override _list: BundlePackage[] = [];

    get hotelPackageList(): HotelPackage[] {
        return this.list.map(b => b.hotelPackage);
    }

    get hotelPackageSet(): HotelPackageSet {
        const hotelPackageSet = new HotelPackageSet(
            {
                adultCount: 0,
                childCount: 0,
                cityName: '',
                fromDate: '',
                roomCount: 0,
                static: false,
                toDate: '',
            },
            this.filters,
            this.minPrice
        );
        // hotelPackageSet.list = this.hotelPackageList;
        hotelPackageSet.filterMetaData = this.filterMetaData;
        return hotelPackageSet;
    }

    /**
     * filters
     *
     * @type {HotelSortBy}
     * @memberof HotelPackageSet
     */
    override sortBy: HotelSortBy = HotelSortBy.HigherScore;

    protected override reset(
        config: BundlePackageLoaderConfig,
        filters: Record<FilterKey, any>,
        minPrice?: number
    ) {
        super.reset(config, filters, minPrice);
        this.loader = new BundlePackageLoader(config);
        this.sortBy = HotelSortBy.HigherScore;
    }

    constructor(
        config: BundlePackageLoaderConfig,
        /**
         * Contains filters that must be applied to the results
         */
        filters: Record<FilterKey, any>,

        /**
         * Minimum price that is obtained or expected from the current package set
         */
        public override minPrice?: number
    ) {
        super(filters, minPrice);
        this.loader = new BundlePackageLoader(config);
    }
}
